module.exports = __webpack_public_path__ + "static/img/blog.ad49c14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog.jpg
// module id = C79M
// module chunks = 0